import { PlusCircle } from 'feather-icons-react/build/IconComponents'
import React, { useState, useEffect } from 'react'
import { useToast } from '../../../Toaster/ToastContext'
import PropTypes from 'prop-types';
import { apiClient } from '../../../services/apiClient';

const imageStyles = {
    imagePreviewContainer: {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    previewImage: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
    },
    removeImageBtn: {
        position: 'absolute',
        top: '5px',
        right: '5px',
        background: 'rgba(255, 255, 255, 0.8)',
        border: 'none',
        borderRadius: '50%',
        width: '25px',
        height: '25px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        fontSize: '18px',
        color: '#dc3545',
        padding: 0,
    },
};

export default function AddBrand({ brand, onSave }) {

    const { showToast } = useToast();
    const [imagePreview, setImagePreview] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        brand_image: '',
        status: 'Active',
    });
    const [permissions, setPermissions] = useState({
        create: false,
        read: false,
        update: false,
        delete: false,
    });

    useEffect(() => {
    const storedPermissions = localStorage.getItem("rolespermissions");
    let parsedPermissions = [];
        try {
            const Permissions = JSON.parse(storedPermissions);
            const getPermissions = JSON.parse(Permissions.permissions)
            if(getPermissions.permissions){
                parsedPermissions = getPermissions.permissions;
            }
            else {
                parsedPermissions = getPermissions;
            }

            const inventoryPermissions = parsedPermissions.find(
                (item) => item.title === "Inventory"
            );

            const productPermissions = inventoryPermissions?.childPage?.find(
                (child) => child.title === "Brands"
            );
            // console.log("search product", productPermissions)

            if (productPermissions) {
                setPermissions({
                    create: productPermissions.create || false,
                    read: productPermissions.read || false,
                    update: productPermissions.update || false,
                    delete: productPermissions.delete || false,
                });
            } else {
                console.error("Product permissions not found in localStorage");
                showToast("Product permissions not found.", "error", "Permissions Error");
            }
        } catch (error) {
            console.error("Error parsing permissions from localStorage:", error);
            showToast("Failed to load permissions.", "error", "Permissions Error");
        }
    }, []);

    useEffect(() => {
        if (brand) {
            setFormData({
                id: brand.id,
                name: brand.name || '',
                brand_image: brand.brand_image || '',
                status: brand.status || 'Active',
            });
            setImagePreview(brand.brand_image || null);
        } else {
            setFormData({ name: '', brand_image: '', status: 'Active' });
        }
        setErrors({ name: '', status: '' });
    }, [brand]);

    const [errors, setErrors] = useState({
        name: '',
        status: '',
    });

    const validateField = (name, value) => {
        switch (name) {
            case 'name':
                return value.trim() ? '' : 'Brand Name is required';
            case 'status':
                return value ? '' : 'Status is required';
            default:
                return '';
        }
    };

    const validateForm = () => {
        const newErrors = {
            name: validateField('name', formData.name),
            status: validateField('status', formData.status),
        };
        setErrors(newErrors);
        return !Object.values(newErrors).some((error) => error !== '');
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
                setFormData(prev => ({ ...prev, brand_image: reader.result }));
            };
            reader.readAsDataURL(file);
            setImageFile(file);
        }
    };

    const handleRemoveImage = () => {
        setImagePreview(null);
        setImageFile(null);
        setFormData(prev => ({ ...prev, brand_image: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            try {
                const formDataToSend = new FormData();
                formDataToSend.append('name', formData.name);
                formDataToSend.append('status', formData.status);
                
                if (imageFile) {
                    formDataToSend.append('brand_image', imageFile);
                }

                else {
                    formDataToSend.append('brand_image', brand.brand_image);
                }
                
                if (formData.id) {
                    formDataToSend.append('id', formData.id);
                }

                const response = await apiClient.post('/store-update-brand', formDataToSend, true);
                const Apidata = await response;
                
                if (Apidata.success) {
                    onSave && onSave();
                    // Reset form
                    setFormData({ name: '', brand_image: '', status: 'Active' });
                    setImagePreview(null);
                    setImageFile(null);
                    setErrors({ name: '', status: '' });
                    document.getElementById('add-brand').querySelector('[data-bs-dismiss="modal"]').click()
                    
                    // Show toast and call onSave
                    showToast(Apidata.message, 'success', 'Brand Operation!');
                } else {
                    showToast(Apidata.message || 'Failed to save brand', 'error', 'Brand Operation!');
                }
            }
            catch (error) {
                showToast(error.message || 'An unexpected error occurred: Please contact the support team.', 'error', 'Brand Operation!');
            }
        }
    };

    return (
        <>
            {/* Add Brand */}
            <div className="modal fade" id="add-brand">
                <div className="modal-dialog modal-dialog-centered custom-modal-two">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header d-flex justify-content-between align-items-center">
                                    <div className="page-title">
                                        <h4>Create Brand</h4>
                                    </div>
                                    <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body new-employee-field">
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label className="form-label">Brand</label>
                                            <input 
                                                type="text" 
                                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                name="name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                            />
                                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                        </div>
                                        <label className="form-label">Logo</label>
                                        <div className="profile-pic-upload mb-3">
                                            <div className="profile-pic brand-pic">
                                                {imagePreview ? (
                                                    <div style={imageStyles.imagePreviewContainer}>
                                                        <img 
                                                            src={imagePreview} 
                                                            alt="Brand" 
                                                            style={imageStyles.previewImage} 
                                                        />
                                                        <button type="button" style={imageStyles.removeImageBtn} onClick={handleRemoveImage}>
                                                            ×
                                                        </button>
                                                     </div>
                                                ) : (
                                                    <span>
                                                        <PlusCircle className="plus-down-add"/>
                                                        Add Image
                                                    </span>
                                                )}
                                            </div>
                                            <div className="image-upload mb-0" style={{ cursor: 'pointer' }}>
                                                <input 
                                                    type="file" 
                                                    accept="image/*"
                                                    onChange={handleImageUpload}
                                                />
                                                <div className="image-uploads">
                                                    <h4 style={{ cursor: 'pointer' }}>Change Image</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mb-0">
                                            <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                                                <span className="status-label">Status</span>
                                                <select
                                                    className={`form-select ${errors.status ? 'is-invalid' : ''}`}
                                                    name="status"
                                                    value={formData.status}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="Active">Active</option>
                                                    <option value="Inactive">Inactive</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="modal-footer-btn">
                                            <button type="button" className="btn btn-cancel me-2" data-bs-dismiss="modal">
                                                Cancel
                                            </button>
                                            {(brand ? permissions.update : permissions.create) && (
                                                <button type="submit" className="btn btn-submit">
                                                    {brand ? 'Update Brand' : 'Create Brand'}
                                                </button>
                                            )}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Brand */}
        </>
    )
}

AddBrand.propTypes = {
    brand: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        brand_image: PropTypes.string,
        status: PropTypes.oneOf(['Active', 'Inactive', '']),
    }),
    onSave: PropTypes.func,
};

AddBrand.defaultProps = {
    brand: null,
};
